export default __webpack_public_path__ + "static/media/rightArrow.9355312e.svg";